import { Drawer, GlobalToken } from 'antd';
import styled from 'styled-components';

export const StyledBaseDrawer = styled(Drawer)<{ theme: { token: GlobalToken } }>`
  &.custom-base-drawer {
    .ant-drawer-content {
      background: ${({ theme: { token } }) => token.colorBgElevated};
      border-top-left-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
      border-top-right-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    }

    .ant-drawer-header {
      background: ${({ theme: { token } }) => token.colorBgElevated};
      border-bottom: none;
      padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingLG}px
        ${({ theme: { token } }) => token.paddingXS}px;
    }

    .ant-drawer-close {
      position: absolute;
      right: ${({ theme: { token } }) => token.paddingLG}px;
      top: ${({ theme: { token } }) => token.padding}px;
      margin: 0;
      padding: 0;
    }

    .ant-drawer-body {
      padding: 0;
      background: ${({ theme: { token } }) => token.colorBgElevated};
    }

    .drawer-content {
      display: flex;
      flex-direction: column;
    }

    .base-drawer-header {
      padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingLG}px
        ${({ theme: { token } }) => token.padding}px;
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    }

    .base-drawer-content-section {
      padding: ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.padding}px;
      display: flex;
      flex-direction: column;
      gap: ${({ theme: { token } }) => token.paddingLG}px;
      flex: 1;
    }

    .base-drawer-footer {
      padding: 0 ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.padding}px;
    }
  }
`;

export const CloseIconWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  width: ${({ theme: { token } }) => token.controlHeight / 2}px;
  height: ${({ theme: { token } }) => token.controlHeight / 2}px;
  padding: ${({ theme: { token } }) => token.paddingXXS}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  line-height: ${({ theme: { token } }) => token.lineHeightLG};
`;

export const ActionContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.paddingLG}px;
`;
